import * as React from "react";
const Line = (props) => {
    const { className, curved, source, target } = props;
    const top = Math.min(target.y, source.y) - 2;
    const left = Math.min(target.x, source.x);
    const boxWidth = Math.abs(target.x - source.x) + 80;
    const boxHeight = Math.abs(target.y - source.y) + 4;
    const path = curved
        ? `M ${source.x - left} ${source.y - top}
  Q ${boxWidth} ${boxHeight / 2} ${target.x - left} ${target.y - top}`
        : `M ${source.x - left} ${source.y - top} L ${target.x - left} ${target.y - top}`;
    return (React.createElement("svg", { width: boxWidth, height: boxHeight, style: { position: "fixed", top, left, pointerEvents: "none" } },
        React.createElement("path", { className: className, d: path, fill: "none" })));
};
export default Line;
